import { AppRoutes } from '@core/AppRoutes'
import {
  ACCOUNT_ACTIVITY_PENDING_ROUTE,
  ACCOUNT_ACTIVITY_RESULTS_ROUTE,
} from '@core/Areas/Account/Pages/Activity/constants'
import { MyBetsTab } from '@core/Areas/Account/Pages/MyBets/types'
import {
  KAMBI_PENDING_HASH_ROUTE,
  KAMBI_RESULTED_HASH_ROUTE,
  KAMBI_ROOT_ROUTE,
} from '@core/Areas/KambiClient/constants'
import { getWapi } from '@core/Areas/KambiClient/helpers'
import { store } from '@core/Store'
import { appHistory } from '@core/Utils/routing/history'
import { trackPendingBetsButtonClick } from '../Components/MyBetsButtons/analytics'
import { DisplayLocation } from '../Components/MyBetsButtons/types'
import { setBetSlipIsOpen, setIsPreviousPendingBetsSportsOnly } from '../Store'
import { selectIsPreviousPendingBetsSportsOnly } from '../Store/selectors'

export const navigateToMyBets = ({
  pendingBetsCount,
  isSportsOnlyPending,
  displayLocation,
  tab,
  isUnifiedMyBetsFeatureActive,
}: {
  isSportsOnlyPending: boolean
  pendingBetsCount: number | null
  displayLocation: DisplayLocation
  tab: MyBetsTab
  isUnifiedMyBetsFeatureActive: boolean
}) => {
  if (isUnifiedMyBetsFeatureActive) {
    appHistory.push(AppRoutes.MyBets.replace(':tab', tab))
  } else {
    const myBetsRoute = getMyBetsRoute({
      pendingBetsCount,
      isSportsOnlyPending,
      displayLocation,
    })
    appHistory.push(myBetsRoute)
    if (myBetsRoute.includes(KAMBI_ROOT_ROUTE)) {
      getWapi().then(wapi => wapi.navigateClient(myBetsRoute))
    }
  }

  trackPendingBetsButtonClick(displayLocation)

  if (displayLocation === 'betslip') {
    store.dispatch(setBetSlipIsOpen(false))
  }
}

// ============
// Local Helper
// ============

function getMyBetsRoute({
  pendingBetsCount,
  isSportsOnlyPending,
  displayLocation,
}: {
  isSportsOnlyPending: boolean
  pendingBetsCount: number | null
  displayLocation: DisplayLocation
}): `/${string}` {
  if (pendingBetsCount === null) return `/${ACCOUNT_ACTIVITY_PENDING_ROUTE}`

  const isPreviousPendingSportsOnly = selectIsPreviousPendingBetsSportsOnly(store.getState())

  if (pendingBetsCount === 0) {
    return isPreviousPendingSportsOnly
      ? KAMBI_RESULTED_HASH_ROUTE
      : `/${ACCOUNT_ACTIVITY_RESULTS_ROUTE}`
  }

  if (isSportsOnlyPending && displayLocation !== 'betslip') {
    store.dispatch(setIsPreviousPendingBetsSportsOnly(true))
    return KAMBI_PENDING_HASH_ROUTE
  }

  store.dispatch(setIsPreviousPendingBetsSportsOnly(false))
  return `/${ACCOUNT_ACTIVITY_PENDING_ROUTE}`
}
